import { format, parseISO } from 'date-fns';
import pt from 'date-fns/locale/pt';

export default function formatCompleteDate(date) {
  let dateObj;
  if (!(date instanceof Date)) {
    dateObj = parseISO(date);
  } else {
    dateObj = date;
  }
  
  // A data vem em UTC, precisamos subtrair 3 horas para obter o horário de Brasília
  const brasiliaDate = new Date(dateObj.getTime());
  
  return format(brasiliaDate, 'dd/MM/yyyy - HH:mm', {
    locale: pt,
  });
}
